import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  Table, Button, Typography, Select, DatePicker, Row, Col, Modal, Popover, message
} from 'antd';
import { SearchOutlined, InfoCircleOutlined, SyncOutlined } from '@ant-design/icons';
import AdvancedSearchForm from '../../../common/SearchForm';
import DetailDrawer from './components/detailDrawer';

const { Title, Link } = Typography;
const { Option } = Select;

function AppointmentClinic(props) {

  const vendorEquipmentRefresh = useSelector(state => state.vendorEquipmenReducer.allBookingsRefresh);

  const [descriptionModal, setDescriptionModal] = useState(false);
  const [currentColumn, setCurrentColumn] = useState({});
  const [logsVisible, setLogsVisible] = useState(false);
  const [searchOption, setSearchOption] = useState(false);
  const [currentPage,setCurrentPage]=useState(1);

  const handleOk = () => {
    setLogsVisible(false);
    setCurrentColumn({});
  };

  const handleLogsCancel = () => {
    setLogsVisible(false);
    setCurrentColumn({});
  };

  const renderData = useCallback((currentPage) => {
    props.getAllAtmedBookingLab(undefined,20,currentPage);
  }, [props.getAllAtmedBookingLab])

  useEffect(() => {
    renderData(currentPage);
  }, [renderData,currentPage]);

  const handleRefresh = () => {
    props.getAllAtmedBookingLab(undefined,20,currentPage);
    if (vendorEquipmentRefresh && vendorEquipmentRefresh) {
      message.success(vendorEquipmentRefresh.message);
    }
  }

  const columns = [
    {
      title: 'CLINIC',
      key: 'booking_id',
      dataIndex: 'booking_id',
      width: '25%',
      render: (_, columnData) => (
        <Row className="name-details-row">
          <Col span={14} offset={1}>
            <div className="table-fc-name">{columnData.branch_name}</div>
            <div className="table-fc-email">Booking ID: {columnData.orderid}
            </div>
            <div className="table-fc-email">
              Date: {columnData.order_date}
            </div>
            <div className="view-details">
              <Link onClick={() => { setDescriptionModal(true); setCurrentColumn(columnData); }}>
                VIEW DETAILS
              </Link>
            </div>
          </Col>
        </Row>
      ),
    },
    {
      title: 'Patient Details',
      key: 'patient_name',
      width: '20%',
      render: (_, columnData) => (
        <>
          <Row>
            <Col span={24}>
              {columnData.patient_name} </Col>
            <Col span={24} className="lightFont">
              {columnData.patient_age} / {columnData.patient_gender}</Col>
            <Col span={24} className="lightFont">
              {columnData.patient_phone}</Col>
          </Row>
          <Row>
            <Col span={24} className="lightFont">
              {columnData.schedule_date}
            </Col>
            <Col span={24} className="lightFont">
              ({columnData.schedule_time})
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: 'Test Details',
      key: 'name',
      dataIndex: 'product_name',
      width: '25%',
      render: (_, columnData) => (
        <>
          <div>{columnData.tests}</div>
          <div className="lightFont">{columnData.branch_name}</div>
        </>
      ),
    },
    // {
    //   title: 'Booking Details',
    //   key: 'patient_name',
    //   width: '25%',
    //   render: (_, columnData) => (
    //     <>
    //       <Row>
    //         <Col span={24}>
    //           {columnData.medic_name} </Col>
    //       </Row >
    //       <Row>
    //         <Col span={24} className="lightFont">
    //           {columnData.medic_speciality}</Col>
    //       </Row>
    //       <Row>
    //         <Col span={24} className="lightFont">
    //           Schdule: {columnData.schedule_date}</Col>
    //       </Row>
    //       <Row>
    //         <Col span={24} className="lightFont">
    //           ({columnData.schedule_time})</Col>
    //       </Row>
    //     </>
    //   ),
    // },
    // {
    //   title: 'Status',
    //   key: 'status_code',
    //   dataIndex: 'status_code',
    //   width: '25%',
    //   render: (_, columnData) => (
    //     <Row>
    //       <Col span={24}>
    //         {columnData.status_code === 1 ? (
    //           <span className="booking-placed">{columnData.status}</span>
    //         ) : null}
    //         {columnData.status_code === 2 ? (
    //           <span className="booking-confirmed">{columnData.status}</span>
    //         ) : null}
    //         {columnData.status_code === 3 ? (
    //           <span className="booking-inprogress">{columnData.status}</span>
    //         ) : null}
    //         {columnData.status_code === 4 ? (
    //           <span className="booking-completed">{columnData.status}</span>
    //         ) : null}
    //         {columnData.status_code === 5 ? (
    //           <span className="booking-cancelled">{columnData.status}</span>
    //         ) : null}
    //       </Col>
    //       <Col span={24} className="fw500">
    //         Consult Fee: {columnData.currency}{columnData.consult_fee}
    //       </Col>
    //       <Col span={24}>Payment{`  `}
    //         {columnData.payment_status === true ? (
    //           <span className="inActivateNotverified">Pending</span>
    //         ) : <span className="activate">Completed</span>}
    //       </Col>
    //     </Row>
    //   ),
    // }
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (_, columnData) => (
        <>
          <Col span={24}>
            {columnData.status_code === 1 ? (
              <span className="booking-placed">{columnData.status}</span>
            ) : null}
            {columnData.status_code === 2 ? (
              <span className="emergency-book-confirm">{columnData.status}</span>
            ) : null}
            {columnData.status_code === 3 ? (
              <span className="booking-inprogress">{columnData.status}</span>
            ) : null}
            {columnData.status_code === 4 ? (
              <span className="booking-completed">{columnData.status}</span>
            ) : null}
            {columnData.status_code === 5 ? (
              <span className="booking-cancelled">{columnData.status}</span>
            ) : null}
          </Col>
          {/* <Col><div className="lightFont">{columnData.order_date.substring(0, 11)}</div>
            <div className="lightFont">{columnData.order_date.substring(15, 22)}</div></Col> */}
          {columnData.technician  && 
          <Col>
            <div>Lab Technician:</div>
            <div className="lightFont">{columnData.tecnician_name}</div>
            <div className="lightFont">{columnData.tecnician_phone}</div>
          </Col>
          }
          {columnData.payment_status  && 
          <>
            <span className="fw500">Payment Status</span>
            <Popover
              content={(
                <>
                  <Row>
                    <Col span={18}>Payment Status</Col>
                    <Col span={6} className="fw500">
                      {columnData.payment_status ? (
                        <span className="activate">Active</span>
                      ) : (
                        <span className="inActivateNotverified">Blocked</span>
                      )}
                    </Col>
                    <Col span={18}>Total Payable</Col>
                    <Col span={6} className="fw500">{columnData.total_payable}</Col>
                  </Row>
                </>
              )}

              // title="Receivable Amount"
            >
              <Button type="text" icon={<InfoCircleOutlined />} />
            </Popover>       
          </>
          }   
        </>
      ),
    }
  ];
  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join('&');
    props.getAllAtmedBookingLab(queryString,20,currentPage);
  };

  const toggleSearch = () => {
    setSearchOption(!searchOption)
  };

  return (
    <div>
      <Modal className="logs-modal" title="Prescription" footer={false} visible={logsVisible} onOk={handleOk} onCancel={handleLogsCancel}>
        <p><span>Prescription : </span>{currentColumn.prescription && currentColumn.prescription.html}</p>
      </Modal>
      <DetailDrawer
        data={currentColumn}
        visible={descriptionModal}
        onCancel={() => setDescriptionModal(false)}
      />
      <Row
        gutter={[0, 16]}
      >
        <Col className="gutter-row section-heading" span={12} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: 'space-between', alignItems: 'center' }}
          >
            Lab Tests
          </Title>
        </Col>
        <Col className="gutter-row" span={7} offset={0}>
        </Col>
        <Col className="gutter-row header-buttons" span={3} offset={0}>
          <Button className={`${searchOption === true ? 'search-open' : 'search-close'} search-toggle-button`} onClick={() => toggleSearch()}>
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col className="gutter-row header-buttons" span={2} offset={0}>
          <Button shape="circle" icon={<SyncOutlined />} style={{ marginRight: 8 }} onClick={() => handleRefresh()} />
        </Col> 
      </Row>
      {searchOption === true ?
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Clinic Consultation"
          formItems={[
            {
              key: 'q[orderid_cont]',
              label: 'Order ID',
            },
            {
              key: 'q[module_eq]',
              label: 'Service Name',
              Component: (
                <Select placeholder="Select Service">
                  <Option value="lab_home">Labs at Home</Option>
                  <Option value="lab_near">Labs Near You</Option>
                  <Option value="diagnostic_near">Diagnostics</Option>
                </Select>
              ),
            },
            {
              key: 'q[patient_name_cont]',
              label: 'Patient name',
            },
            {
              key: 'q[status_code_eq]',
              label: 'Status',
              Component: (
                <Select placeholder="Select Order status" size="large">
                  <Option value="1">Order Placed</Option>
                  <Option value="2">Order Confirmed</Option>
                  <Option value="3">In Progress</Option>
                  <Option value="4">Order Completed</Option>
                  <Option value="5">Order Cancelled</Option>
                </Select>
              ),
            },
            {
              key: 'q[created_at_gteq]',
              label: 'From Date',
              Component: (<DatePicker size="large" />),
            },
            {
              key: 'q[created_at_lteq]',
              label: 'To Date',
              Component: (<DatePicker size="large" />),
            },
          ]}
        /> : ''}
     <Table 
      className="list_table" 
      dataSource={props.results?props.results.data:null} 
      pagination={{ pageSize: 20, total: props.results?.total_count, showSizeChanger:false }} 
      columns={columns} 
      scroll={{ x: 800 }} 
      rowKey="id" 
      onChange={(e)=>{
        setCurrentPage(e.current);
      }}
      />
    </div>
  );
}

export default AppointmentClinic;
